<template>
  <div>
    <el-form
      ref="form"
      :model="form"
      label-width="80px"
      style="margin-top: 20px;"
    >
      <el-form-item label="来访者" style="float: left;">
        <el-input v-model="form.name"></el-input>
      </el-form-item>
      <el-form-item label="处理状态" style="float: left;">
        <el-select
          v-model="form.region"
          placeholder="请选择活动区域"
          style="width: 220px;"
        >
          <el-option label="区域一" value="shanghai"></el-option>
          <el-option label="区域二" value="beijing"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        label="时间段"
        style="width: 700px; height: 50px; float: left;"
      >
        <el-col :span="11">
          <el-date-picker
            type="date"
            placeholder="选择日期"
            v-model="form.date1"
            style="width: 220px;"
          ></el-date-picker>
        </el-col>
      </el-form-item>
      <el-form-item style="padding-top: 60px; float: right;">
        <el-button type="primary" plain>重置条件</el-button>
        <el-button type="primary" @click="onSubmit">确认搜索</el-button>
      </el-form-item>
    </el-form>
    <div
      style="
        padding-top: 120px;
        height: 50px;
        font-size: 16px;
        font-weight: 600;
      "
    >
      <span>预约排班列表</span>
      <div>
        <el-button
          type="primary"
          @click="onSubmit"
          style="float: right; margin-left: 20px;"
        >
          + 新添
        </el-button>
        <el-button type="danger" style="float: right;" plain>
          彻底删除
        </el-button>
      </div>
    </div>
    <el-table
      :data="tableData"
      style="width: 100%; background-color: rgba(242, 242, 242, 1);"
    >
      <el-table-column prop="li1" label="序列" width="60"></el-table-column>
      <el-table-column prop="li2" label="姓名" align="center"></el-table-column>
      <el-table-column
        prop="li3"
        label="排班日期"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="li4"
        label="时间段"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="li5"
        label="人数限制"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="li6"
        label="取消预约限制"
        align="center"
      ></el-table-column>
      <el-table-column prop="li7" label="状态" align="center"></el-table-column>
      <el-table-column
        prop="li8"
        label="是否启用"
        align="center"
      ></el-table-column>
      <el-table-column
        prop="li9"
        label="创建时间"
        align="center"
      ></el-table-column>

      <el-table-column fixed="right" label="操作">
        <template slot-scope="scope">
          <el-button @click="handleClick(scope.row)" type="text" size="small">
            查看
          </el-button>
          <el-button type="text" size="small" @click="dialogfun(scope.row)">
            编辑
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      title="详情"
      :visible.sync="dialogVisible"
      width="40%"
      :before-close="handleClose"
    >
      <span>{{ dialog.li1 }}</span>
      <span>{{ dialog.li2 }}</span>
      <span>{{ dialog.li3 }}</span>
      <span>{{ dialog.li4 }}</span>
      <span>{{ dialog.li5 }}</span>
      <span>{{ dialog.li6 }}</span>
      <span>{{ dialog.li7 }}</span>
      <span>{{ dialog.li8 }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="dialogVisible = false">
          确 定
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,

      tableData: [
        {
          li1: '1',
          li2: '王小虎',
          li3: '2020-10-01',
          li4: '8:00-9:00',
          li5: '1',
          li6: '0',
          li7: '已发布',
          li8: '启用',
          li9: '2020-10-01',
        },
        {
          li1: '2',
          li2: '王小虎',
          li3: '2020-10-01',
          li4: '8:00-9:00',
          li5: '1',
          li6: '0',
          li7: '已发布',
          li8: '启用',
          li9: '2020-10-01',
        },
        {
          li1: '3',
          li2: '王小虎',
          li3: '2020-10-01',
          li4: '8:00-9:00',
          li5: '1',
          li6: '0',
          li7: '已发布',
          li8: '启用',
          li9: '2020-10-01',
        },
        {
          li1: '4',
          li2: '王小虎',
          li3: '2020-10-01',
          li4: '8:00-9:00',
          li5: '1',
          li6: '0',
          li7: '已发布',
          li8: '启用',
          li9: '2020-10-01',
        },
        {
          li1: '5',
          li2: '王小虎',
          li3: '2020-10-01',
          li4: '8:00-9:00',
          li5: '1',
          li6: '0',
          li7: '已发布',
          li8: '启用',
          li9: '2020-10-01',
        },
        {
          li1: '6',
          li2: '王小虎',
          li3: '2020-10-01',
          li4: '8:00-9:00',
          li5: '1',
          li6: '0',
          li7: '已发布',
          li8: '启用',
          li9: '2020-10-01',
        },
      ],
      dialog: '',
      form: {
        name: '',
        region: '',
        date1: '',
        date2: '',
        delivery: false,
        type: [],
        resource: '',
        desc: '',
      },
    }
  },
  methods: {
    onSubmit() {},
    handleClick(row) {},
    handleClose() {
      this.dialogVisible = false

    },
    dialogfun(row) {
      this.dialogVisible = true
      this.dialog = row

    },
  },
}
</script>
<style scoped>
h2 {
  margin-bottom: 20px;
  font-size: 18px;
}
.el-col-11 {
  width: 38.83333%;
}
</style>
